'use client';

import { useEffect } from 'react';

/**
 * Per-landing-page analytics. GA4 ($page_view) + PostHog ($pageview) already
 * fire site-wide via the root layout, so this only ADDS the LP dimension:
 * registers `lp_key` as a PostHog super-property (so every subsequent event +
 * the eventual signup carries it) and fires an `lp_view`. This is what lets us
 * compare "which landing page converts best" in PostHog funnels / the
 * /admin/attribution dashboard. All calls are guarded + swallow errors so
 * analytics can never break the page.
 */
export function LpAnalytics({ lpKey }: { lpKey: string }) {
  useEffect(() => {
    try {
      const ph = (window as unknown as { posthog?: { register?: (p: Record<string, unknown>) => void; capture?: (n: string, p?: Record<string, unknown>) => void } }).posthog;
      if (!ph) return;
      ph.register?.({ lp_key: lpKey });
      ph.capture?.('lp_view', { lp_key: lpKey });
    } catch {
      /* analytics must never break UX */
    }
  }, [lpKey]);

  return null;
}
